varying vec2 vLocalPos; // リング面のローカルXY（半径計算用）

void main()
{
    vLocalPos = position.xy;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
